{
  "USERS": [
    {
      "ADMIN": {
        "ROLE_SCOPE": "CRM",
        "LABEL": "Admin"
      }
    },
    {
      "OWNER": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Owner"
      }
    },
    {
      "OEM": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Admin"
      }
    },
    {
      "STAFF": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Supervisor"
      }
    },
    {
      "TECHNICIAN": {
        "ROLE_SCOPE": "OEM",
        "LABEL": "Technician"
      }
    },
    {
      "PORTAL_USER": {
        "ROLE_SCOPE": "PORTAL_USER",
        "LABEL": "Portal User"
      }
    },
    {
      "USER": {
        "ROLE_SCOPE": "FACILITY",
        "LABEL": "User"
      }
    },
    {
      "GMU": {
        "ROLE_SCOPE": "FACILITY",
        "LABEL": "GMU"
      }
    }
  ]
}
